/**
 * Created by mnaughton on 10/20/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import moment from "moment";
export default BaseFieldView.extend({
  tagName: "span",

  template: function (options) {
    var value = options.value;
    var result = "Never";

    if (value) {
      result = moment(value).fromNow();
    }

    return result;
  },

  getControlValue: function () {
    return this.$el.data("value");
  },

  setControlValue: function (value) {
    this.$el.data("value", value);
    this.render();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/FromNowView.js
// module id = 853
// module chunks = 1